<p-blockUI [target]="dt" [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">Lista Talleres</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="redirectParent()"></button>
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_coordination}}</span>
                        <span class="p-text-bold">{{workShopsTracing != null ? workShopsTracing.storeName  : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_type}} {{lbl_service}}</span>
                        <span class="p-text-bold">{{workshopList != null && workshopList.length > 0 ? workshopList[0].wsName : ""}}	</span>
                    </div>
                   
                </p-panel>
            </div>
        </div>


       

    </div>

    <p-table #dt [value]="workshopList" [rows]="20" [paginator]="true" [globalFilterFields]="['strDate','city','name','country']"
    [rowHover]="true" dataKey="guideId" 
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
    [scrollable]="true" scrollHeight="400px" scrollDirection="both">
    <ng-template pTemplate="caption">
        <div class="p-d-flex p-ai-center p-jc-between">
            <h5 class="p-m-0">{{lbl_participants}} </h5>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="{{lbl_search}}..." />
            </span>
        </div>

        <span class="p-input-icon-left">
            <!--button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button-->
        </span>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="strDate">{{lbl_service}}<p-sortIcon field="strDate"></p-sortIcon>
            </th>
            <th pSortableColumn="strDate">{{lbl_starting_date}}<p-sortIcon field="strDate"></p-sortIcon>
            </th>
            <th pSortableColumn="fromTime">{{lbl_starting_time}}<p-sortIcon field="fromTime"></p-sortIcon>
            </th>
            <th pSortableColumn="toTime">{{lbl_ending_time}}<p-sortIcon field="toTime"></p-sortIcon>
            </th>
            <th pSortableColumn="city">{{lbl_name_guide_who_taught}}<p-sortIcon field="city"></p-sortIcon>
            </th>
            <th pSortableColumn="city">{{lbl_city}}<p-sortIcon field="city"></p-sortIcon>
            </th>
           
            <th pSortableColumn="country">{{lbl_country}}<p-sortIcon field="country"></p-sortIcon>
            </th>
            <th pSortableColumn="state">{{lbl_state}}<p-sortIcon field="state"></p-sortIcon>
            </th>
        

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-wkrs>
        <tr>
            <td >{{wkrs.wsName}}</td>
            <td >{{wkrs.strDate}}</td>
            <td >{{wkrs.fromTime}}</td>
            <td >{{wkrs.toTime}}</td>
            <td >{{wkrs.name}} {{wkrs.lastName}}</td>
            <td >{{wkrs.city}}</td>                    
            <td >{{wkrs.country}}</td>
            <td >{{wkrs.state}}</td>

        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
            {{lbl_total}} {{lbl_there_are}} {{listImportGuides ? listImportGuides.length : 0 }} {{lbl_guide}}.
        </div>
    </ng-template>
</p-table>

</p-fieldset>